"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsureContact = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const insurer_entity_1 = require("./insurer.entity");
const contact_entity_1 = require("./contact.entity");
let InsureContact = class InsureContact {
};
exports.InsureContact = InsureContact;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], InsureContact.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", Number)
], InsureContact.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], InsureContact.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer, (insurer) => insurer.insurerContacts, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", Object)
], InsureContact.prototype, "insurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.insurerContacts, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], InsureContact.prototype, "contact", void 0);
exports.InsureContact = InsureContact = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "insurer_contact" })
], InsureContact);
